import { useCallback, useEffect, useState } from "react";

import { ProjectFormData } from "@/types/project";

import { useDebounce } from "../useDebounce";

export const useProjectForm = (
  initialData: ProjectFormData,
  onUpdate: (data: ProjectFormData) => void
) => {
  const [formData, setFormData] = useState<ProjectFormData>(initialData);
  const debouncedFormData = useDebounce(formData, 500); // Use useDebounce

  useEffect(() => {
    onUpdate(debouncedFormData); // Call onUpdate with the debounced data
  }, [debouncedFormData, onUpdate]);

  const handleChange = useCallback(
    (value: string, name: string) => {
      setFormData({ ...formData, [name]: value });
    },
    [formData]
  );

  return {
    formData,
    handleChange
  };
};
